export function shadesOf(hex: string) {
  const baseColor = hexToRgbArray(hex);
  const black = [0, 0, 0];
  const white = [255, 255, 255];

  let shades = [
    25, 50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 550, 600, 650, 700,
    750, 800, 850, 900, 950,
  ] as const;

  let result = {} as { [key in (typeof shades)[number]]: string };

  for (let shade of shades) {
    const originalShade = shade;

    if (shade === 500) {
      result[shade] = hex;
      continue;
    }

    let isDarkShade = shade > 500;
    if (isDarkShade) shade -= 500;

    const percentage = shade / 500;
    const startColor = isDarkShade ? black : baseColor;
    const endColor = isDarkShade ? baseColor : white;

    result[originalShade] = getColor(percentage, startColor, endColor);
  }

  return result;
}

function hexToRgbArray(hex: string) {
  const originalHex = hex;

  hex = hex.replace("#", "");
  if (hex.length === 3) hex = hex + hex;

  const r = hex.substring(0, 2);
  const g = hex.substring(2, 4);
  const b = hex.substring(4, 6);

  const rgb = [r, g, b].map((channelString) => {
    try {
      const channel = parseInt(channelString, 16);
      if (channel < 0 || channel > 255) throw new Error();
      return channel;
    } catch {
      throw new Error(`Invalid hex color provided: ${originalHex}`);
    }
  });

  return rgb;
}

function getColor(percentage: number, start: number[], end: number[]) {
  const rgb = end.map((channel, index) => {
    return Math.round(channel + percentage * (start[index] - channel));
  });

  const hex =
    "#" +
    rgb
      .map((channel) => {
        const component = channel.toString(16);
        if (component.length === 1) return "0" + component;
        return component;
      })
      .join("");
  return hex;
}
